import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "sonner";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";

import AdminLayout from "@/layouts/AdminLayout";
import AdminOverview from "@/pages/admin/Overview";
import AdminUsers from "@/pages/admin/Users";
import AdminWards from "@/pages/admin/Wards";
import FormBuilder from "@/pages/admin/FormBuilder";
import AdminAnalytics from "@/pages/admin/Analytics";
import Submissions from "@/pages/admin/Submissions";
import Monetization from "@/pages/admin/Monetization";
import AuditLog from "@/pages/admin/AuditLog";

import SurveyorLayout from "@/layouts/SurveyorLayout";
import SurveyorWards from "@/pages/surveyor/Wards";
import SurveyorBooths from "@/pages/surveyor/Booths";
import SurveyForm from "@/pages/surveyor/SurveyForm";
import MySubmissions from "@/pages/surveyor/MySubmissions";

import CandidateLayout from "@/layouts/CandidateLayout";
import CandidateWards from "@/pages/candidate/Wards";
import CandidateWardReport from "@/pages/candidate/WardReport";
import CandidatePurchases from "@/pages/candidate/Purchases";

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors closeButton />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/login" element={<Login />} />

          {/* Admin */}
          <Route
            path="/admin"
            element={
              <ProtectedRoute roles={["admin"]}>
                <AdminLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<AdminOverview />} />
            <Route path="users" element={<AdminUsers />} />
            <Route path="wards" element={<AdminWards />} />
            <Route path="form-builder" element={<FormBuilder />} />
            <Route path="submissions" element={<Submissions />} />
            <Route path="analytics" element={<AdminAnalytics />} />
            <Route path="monetization" element={<Monetization />} />
            <Route path="audit-log" element={<AuditLog />} />
          </Route>

          {/* Surveyor */}
          <Route
            path="/surveyor"
            element={
              <ProtectedRoute roles={["surveyor", "admin"]}>
                <SurveyorLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<SurveyorWards />} />
            <Route path="wards/:wardId" element={<SurveyorBooths />} />
            <Route path="wards/:wardId/booths/:boothId" element={<SurveyForm />} />
            <Route path="submissions" element={<MySubmissions />} />
          </Route>

          {/* Candidate */}
          <Route
            path="/candidate"
            element={
              <ProtectedRoute roles={["candidate", "admin"]}>
                <CandidateLayout />
              </ProtectedRoute>
            }
          >
            <Route index element={<CandidateWards />} />
            <Route path="wards/:wardId" element={<CandidateWardReport />} />
            <Route path="purchases" element={<CandidatePurchases />} />
          </Route>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
